import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7527f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "searchArea" }
const _hoisted_3 = { class: "form_group1" }
const _hoisted_4 = { class: "checkbox_container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "企画中止を含む", -1))
const _hoisted_6 = { class: "paging_container" }
const _hoisted_7 = { class: "content_middle" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "frame_table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "common_th userName" }, "企画担当者", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "ResultMessageNull"
}

import axios from "axios";
import { onMounted, watch, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";
import { useStore } from "vuex";
import PankuzuHeader from "@/components/PankuzuHeader.vue";
import SearchSimple from "@/components/search/SearchSimple.vue";
import Paginate from "vuejs-paginate-next";

type SearchResult = typeof search_result.value[0];


export default /*#__PURE__*/_defineComponent({
  __name: 'Kikaku',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  setup(__props) {

const store = useStore();
const router = useRouter();
const props = __props;

//ぱんくずヘッダー
const currentPathList = [
  { name: "企画一覧" },
];
// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);
// 検索関連
// 企画中止を含むかどうかの真偽値
const containsCancel = ref(false);

// データ取得-----------------------------------------------------------
const search_result = ref([] as any); // 検索結果
const executeSearch = async () => {
  try {
    const freeword = store.getters["search/getSearchSimpleState"];
    let url = "";
    // ソート時のデータ取得URL
    if (isSorting.value === true) {
      url = `${store.getters["getBaseUrl"]}/kikaku/?freeword=${freeword}&containsCancel=${containsCancel.value}&order=${sortInfo.value.sortItem}&sort=${sortInfo.value.isKoujun}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`;
    }
    // 通常のデータ取得URL
    else {
      url = `${store.getters["getBaseUrl"]}/kikaku/?freeword=${freeword}&containsCancel=${containsCancel.value}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`;
    }
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });

    search_result.value = response.data.display;
    numberOfTotalData.value = response.data.size;
    firstCount.value = response.data.firstCount;
    finalCount.value = response.data.finalCount;
    getTotalPage();
  } catch (error) {
    console.error("era-", error);
  }
};
onMounted(() => {
  currentPage.value = 1;
  store.commit("search/setPageNumber", currentPage.value);
  executeSearch();
});

// 検索実行
const onSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isSorting.value = false;
  executeSearch();
};

// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref<number>(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
//表示中のページ範囲
let firstCount = ref<number>(0);
let finalCount = ref<number>(0);
// 総ページ数
const numberOfTotalPage = ref<number>(0);
// 現在のページ数
const currentPage = ref<number>(store.getters["search/getPageNumber"]);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  executeSearch();
};

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;
  executeSearch();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

// 企画詳細へ遷移-----------------------------------------------
const openTab = (kikakuId: number) => {
  router.push({ name: "KikakuEdit", query: { kikakuId: kikakuId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main_area", {
      Sidebar_False: !props.isActive_SidebarFlg,
      Sidebar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(PankuzuHeader, {
            isActive_SidebarFlg: props.isActive_SidebarFlg,
            currentPathList: currentPathList
          }, null, 8, ["isActive_SidebarFlg"]),
          _createVNode(SearchSimple, {
            placeholder: '企画のキーワードを入力',
            onOnSearch: onSearch,
            ref: "searchSimple"
          }, null, 512),
          _createVNode(_unref(RouterLink), {
            to: "/kikaku_new",
            class: "btn_green"
          }, {
            default: _withCtx(() => [
              _createTextVNode("新規登録")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((containsCancel).value = $event))
            }, null, 512), [
              [_vModelCheckbox, containsCancel.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, search_result.value.length]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", null, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('kikakuId'))),
                  class: "common_th kikakuID th_sort"
                }, [
                  _createElementVNode("span", null, _toDisplayString(showSortSymbol("kikakuId")), 1),
                  _createTextVNode(" 企画ID ")
                ]),
                _createElementVNode("th", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('title'))),
                  class: "common_th kariTitle th_sort"
                }, [
                  _createElementVNode("span", null, _toDisplayString(showSortSymbol("title")), 1),
                  _createTextVNode(" タイトル ")
                ]),
                _hoisted_10
              ])
            ]),
            (search_result.value.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (kikaku, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(kikaku.kikakuId), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (openTab(kikaku.kikakuId))
                        }, _toDisplayString(kikaku.kikakuMei), 9, _hoisted_12)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(kikaku.userName), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (!search_result.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " ※検索結果はありません "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}
}

})